// Shared countdown logic for travel-window pills on RecommendationCard and Trips.

function startsInDays(w) {
    if (!w?.start) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const start = new Date(w.start + "T00:00:00");
    return Math.round((start - today) / (1000 * 60 * 60 * 24));
}

export function countdownLabel(w) {
    const days = startsInDays(w);
    if (days === null) return null;
    if (days < 0) {
        const end = new Date((w.end || w.start) + "T00:00:00");
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (end >= today) return { text: "Window open now", urgent: true };
        return null;
    }
    if (days > 7) return null;
    if (days === 0) return { text: "Window opens today", urgent: true };
    if (days === 1) return { text: "Window opens tomorrow", urgent: true };
    return { text: `Window opens in ${days} days`, urgent: days <= 3 };
}
